'use client';

import { VARIANT_IDENTIFIER } from '@/modules/experiments/config';
import { useExperiments } from '@/modules/experiments/useExperiments';

type Size = 'small' | 'regular' | 'large';

const THRIFT_HEIGHT: Record<Size, string> = {
  small:
    'calc(var(--line-height-fixed-14) + 2 * var(--padding-fixed-x-small) + 4px)',
  regular:
    'calc(var(--line-height-fixed-16) + 2 * var(--padding-fixed-small) + 4px)',
  large:
    'calc(var(--line-height-fixed-24) + 2 * var(--padding-fixed-small) + 4px)',
};

const LEGACY_HEIGHT = '45px';

/**
 * Height a loading placeholder should reserve for the button that replaces it,
 * so the CTA does not jump as it resolves. The thrift Button is taller than the
 * web-ui-kit one, so the right value depends on which arm renders.
 */
export function useButtonPlaceholderHeight(size: Size = 'large') {
  const { web_thrift_ui_button: decision } = useExperiments([
    'web_thrift_ui_button',
  ]);

  return decision === VARIANT_IDENTIFIER ? THRIFT_HEIGHT[size] : LEGACY_HEIGHT;
}
